(() => {
  const popup = document.getElementById('TopWelcomePopup');
  if (!popup || popup.dataset.initialized || typeof popup.showModal !== 'function') return;
  popup.dataset.initialized = 'true';
  if (/\/(?:cart|checkout|checkouts|account)(?:\/|$)/.test(location.pathname)) return;
  const subscribedKey = 'top_welcome_subscribed_v1';
  const dismissedKey = 'top_welcome_dismissed_v1';
  const storage = (() => {
    for (const name of ['localStorage', 'sessionStorage']) {
      try {
        const candidate = window[name];
        candidate.setItem('top_welcome_storage_check', '1');
        candidate.removeItem('top_welcome_storage_check');
        return candidate;
      } catch {}
    }
    return null;
  })();
  const read = key => { try { return storage?.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { storage?.setItem(key, value); } catch {} };
  const result = popup.querySelector('[data-welcome-result]')?.dataset.welcomeResult;
  const isOwnReturn = location.hash === '#TopWelcomeSignup';
  const delay = Math.max(0, Number(popup.dataset.delaySeconds) || 8) * 1000;
  const dismissDays = Math.max(1, Number(popup.dataset.dismissDays) || 7);
  const dismissedAt = Number(read(dismissedKey)) || 0;
  let returnFocus;
  const waitingForPrivacyChoice = () => {
    const bannerVisible = [...document.querySelectorAll('#shopify-pc__banner, [role="alertdialog"]')].some(node => node.checkVisibility ? node.checkVisibility() : node.getClientRects().length > 0);
    if (bannerVisible) return true;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return true;
    const consent = privacy.currentVisitorConsent();
    const choiceMade = ['analytics', 'marketing', 'preferences'].some(key => consent[key] === 'yes' || consent[key] === 'no');
    return privacy.shouldShowBanner() && !choiceMade;
  };
  const show = () => {
    if (popup.open || waitingForPrivacyChoice() || document.querySelector('dialog[open]')) return;
    returnFocus = document.activeElement;
    popup.showModal();
  };
  const close = () => {
    write(dismissedKey, String(Date.now()));
    popup.close();
    if (returnFocus?.isConnected) returnFocus.focus();
  };
  for (const button of popup.querySelectorAll('[data-welcome-close]')) button.addEventListener('click', close);
  popup.addEventListener('cancel', event => { event.preventDefault(); close(); });
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const box = popup.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
  });
  let scheduled = false;
  const schedule = () => {
    if (waitingForPrivacyChoice()) return;
    if (result === 'success' && isOwnReturn) { write(subscribedKey, '1'); show(); return; }
    if (result === 'error' && isOwnReturn) { show(); return; }
    if (scheduled || !storage || read(subscribedKey) === '1' || Date.now() - dismissedAt < dismissDays * 86400000) return;
    scheduled = true;
    window.setTimeout(() => {
      if (!read(subscribedKey) && Date.now() - (Number(read(dismissedKey)) || 0) >= dismissDays * 86400000) show();
    }, delay);
  };
  document.addEventListener('visitorConsentCollected', () => window.setTimeout(schedule, 1000));
  if (window.Shopify?.customerPrivacy) schedule();
  else window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.2'}], error => { if (!error) schedule(); });
})();
